import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { colors } from '../../../theme';

/**
 * Disclosure banner: Hub support neither expedites nor influences the surrender
 * process (ticket 2530 / QA "PartnerNote Banner").
 */
function PartnerNote({ orgName }: { orgName: string }) {
  return (
    <Box
      sx={{
        bgcolor: colors.primary[50],
        borderRadius: '12px',
        p: { xs: '14px 16px', md: '18px 22px' },
        display: 'flex',
        gap: 1.5,
        alignItems: 'flex-start',
      }}
    >
      <InfoOutlinedIcon sx={{
 fontSize: 20, color: colors.primary.main, flexShrink: 0, mt: '1px',
}}
      />
      <Typography sx={{ fontSize: { xs: 13.5, md: 14.5 }, lineHeight: 1.55 }}>
        {`Please note that while Petcademy is a partner of ${orgName}, we’re unable to expedite or influence the `
          + 'surrender process. Receiving support from Petcademy will not affect your ability to surrender your pet.'}
      </Typography>
    </Box>
  );
}

export default PartnerNote;
